// schema meaning 
// type : indicates if it's a compliance or meme nazer question , this is important for the score. ' 
// lang : in which language the question is written to render it right to left LTR or left to right LTR
// question : the question itself
// options : an array of options 

export const questions = [
    {
        type: 'compliance',
        lang: 'en',
        question: `Dr. Ahmed sends to Amgen that he has already obtained funding for all expenses except travel. Dr Ahmed seeks the funding to cover his flight costs. Which is the best answer?`,
        options: [
            {
                option: 'Amgen provides funding to cover the travel',
                valid: false
            },
            {
                option: 'Amgen buys an air ticket for Dr Ahmed',
                valid: true
            }
            ,
            {
                option: 'Amgen provides funding and makes a payment after a receipt has been submitted by Dr Ahmed',
                valid: false
            }
        ]
    },
    {
        type: 'nazer',
        lang: 'en',
        question: 'Which character famously said, "PIVOT" ?',
        options: [
            {
                option: 'Ross',
                valid: true
            },
            {
                option: 'Phoebe',
                valid: false
            }
            ,
            {
                option: 'Gunther',
                valid: false
            }
        ]
    },
    {
        type: 'compliance',
        lang: 'en',
        question: 'Amgen receives a request from a nephrology Key Opinion Leader for financial Support to attend a local lung conference in February in France. The request is to reimburse for airfare, meals, lodging and admission to the conference. Can the sponsorship request be approved?',
        options: [
            {
                option: 'Yes.. why ? ',
                input:true,
                valid: false
            },
            {
                option: 'No.. why ? ',
                input:true,
                valid: true
            }
        ]
    },
    {
        type: 'compliance',
        lang: 'en',
        question: 'Amgen is asked by a big hospital to be one of the sponsors for 300,000 EGP to local symposium on osteoporosis. In return Amgen will obtain space to display Roll ups with Amgen logo. The hospital is Extremely important to Amgen, should Amgen sponsor ?',
        options: [
            {
                option: 'Yes.. why?',
                input:true,
                valid: false
            },
            {
                option: 'No.. why?',
                input:true,
                valid: true
            }
        ]
    },
    {
        type: 'nazer',
        lang: 'ar',
        question: `Ross and Rachel were/weren’t on a ...`,
        options: [
            {
                option: 'Break',
                valid: true
            },
            {
                option: 'Vacation',
                valid: false
            }
            ,
            {
                option: 'Monogamy',
                valid: false
            }
        ]
    },
    {
        type: 'compliance',
        lang: 'en',
        question: 'An Amgen staff is accompanying a group of HCPs to international congress and when arrived he realized that the registration was not done to one of the HCPs by mistake. The employee should: ',
        options: [
            {
                option: 'Pay directly with AMEX card the registration cost for the doctor on site',
                valid: false
            },
            {
                option: 'Call the agency to send a representative to do the registration',
                valid: true
            }
            ,
            {
                option: 'Pay the amount through his personal credit card',
                valid: false
            }
        ]
    },
    {
        type: 'compliance',
        lang: 'ar',
        question: `What Is MEA CPI score ?`,
        options: [
            {
                option: '39',
                valid: true
            },
            {
                option: '37',
                valid: false
            }
            ,
            {
                option: '41',
                valid: false
            },
            {
                option: '43',
                valid: false
            }
        ]
    },
    {
        type: 'compliance',
        lang: 'en',
        question: 'What Does BCR stand for ?',
        options: [
            {
                option: 'Binding Corporate Rule',
                valid: true
            },
            {
                option: 'Breakpoint cluster region',
                valid: false
            }
            ,
            {
                option: 'Benefit Cost Ratio',
                valid: false
            }
            ,
            {
                option: 'Binding compliance Regimen',
                valid: false
            }
        ]
    },
    {
        type: 'nazer',
        lang: 'ar',
        question: 'Joey doesn’t share what ?',
        options: [
            {
                option: 'Clothes',
                valid: false
            },
            {
                option: 'Food',
                valid: true
            }
            ,
            {
                option: 'Pens',
                valid: false
            }
        ]
    },
    {
        type: 'compliance',
        lang: 'en',
        question: 'Meals threshold Eli',
        options: [
            {
                option: 'Lunch - 80 $,Dinner – 80$ ',
                valid: true
            },
            {
                option: 'Lunch - 40 $,Dinner – 70$ ',
                valid: false
            }
            ,
            {
                option: 'Lunch - 90 $,Dinner – 100$',
                valid: false
            },
            {
                option: 'Lunch - 40$,Dinner – 80$',
                valid: false
            }
        ]
    }
    
]